<template>
  <v-card
    class="text-center"
    color="transparent"
    flat
  >
    <v-img
      aspect-ratio="16/9"
      height="80"
      :src="require('@/assets/logo_mini.png')"
      contain
    />
    <v-card-title
      class="font-weight-bold justify-center"
      primary-title
    >
      {{ $t('login.dematerializedInvoices') }}
    </v-card-title>
    <v-card-text v-if="showDescription()">
      {{ $t('login.description') }}
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    name: 'WelcomeCard',
    methods: {
      showDescription () {
        return !this.$mobileDetect.phone() && window.innerHeight >= 680
      },
    },
  }
</script>
